import { routes } from "../../app/routes";
import type { AvatarGesture, AvatarLoop } from "../avatar";
import type { NavIconName } from "./NavIcon";

type Reaction = { gesture: AvatarGesture } | { hold: AvatarLoop };

/**
 * The destinations of the main navigation, and what Orla does when a visitor's
 * pointer or focus lands on each: she waves hello at her blog, runs off towards her inbox,
 * and jumps at the mention of what she has been up to.
 */
export const NAV_ITEMS: { label: string; to: string; icon: NavIconName; reaction: Reaction }[] = [
  { label: "Orla's Blog", to: routes.blog(), icon: "blog", reaction: { gesture: "Wave" } },
  { label: "Orla's Shop", to: routes.shop(), icon: "shop", reaction: { gesture: "Wave" } },
  { label: "Email Orla", to: routes.contact(), icon: "email", reaction: { hold: "Run" } },
  {
    label: "What I've Been Up To",
    to: routes.updates(),
    icon: "updates",
    reaction: { gesture: "Jump" },
  },
];

/** Donating is worth cheering about. */
export const DONATE_REACTION: Reaction = { gesture: "Cheer" };
